declare global {
  interface Window {
    dataLayer: any[];
    GET_OID: () => string;
    WEBPAGE_SESSION_ID: string;
    GET_WEBPAGE_SESSION_ID: () => string;
    CREATE_ID: (size: number) => string;
    LOG_ENABLED: boolean;
    FB_VARS: {
      _fbp: string
      _fbc: string
    };
    Marketech: {
      track: (eventName: string, eventData: any) => void;
    };
    MarketechQueue: any[]
  }
}

const ID_SIZE = 15


function logEvent(name: string, event: any) {
  if (window.LOG_ENABLED) {
    console.log(name, event);
  }
}

function marktechTrack(event: string, properties: any) {
  if(window.Marketech) return window.Marketech.track(event, properties);
  window.MarketechQueue = window.MarketechQueue || []
  window.MarketechQueue.push(["track", event, properties])
}

export function gtmCompleteRegistration() {
  window.dataLayer = window.dataLayer || [];
  const data = {
    'event': 'completeRegistration',
    'session_id': window.GET_WEBPAGE_SESSION_ID(),
    'oid': window.GET_OID(),
    'cid': '133',
    'leadTypeId': '74',
    'eventDedupId': window.CREATE_ID(ID_SIZE),
    'version': '6'
  }
  window.dataLayer.push(data);
  logEvent('GTM: CompleteRegistration', data)
}


export function gtmLead(email: string, phone: string) {
  window.dataLayer = window.dataLayer || [];
  const data = {
    'event': 'lead',
    'userEmail': email,
    'userPhone': phone,
    'leadTypeId': '74',
    'cid': '133',
    'session_id': window.GET_WEBPAGE_SESSION_ID(),
    'eventDedupId': window.CREATE_ID(ID_SIZE)
  }

  window.dataLayer.push(data);
  logEvent('GTM: lead', data)
}

export function gtmSigned(email: string, phone: string) {
  window.dataLayer = window.dataLayer || [];
  const data = {
    'event': 'signed',
    'userEmail': email,
    'userPhone': phone,
    'leadTypeId': '74',
    'cid': '133',
    'session_id': window.GET_WEBPAGE_SESSION_ID(),
    'eventDedupId': window.CREATE_ID(ID_SIZE)
  };

  window.dataLayer.push(data);
  logEvent('GTM: signed', data)
}

export function gtmCreditCheck(email: string, phone: string) {
  window.dataLayer = window.dataLayer || [];
  const data = {
    'event': 'creditCheck',
    'userEmail': email,
    'userPhone': phone,
    'leadTypeId': '74',
    'cid': '133',
    'session_id': window.GET_WEBPAGE_SESSION_ID(),
    'eventDedupId': window.CREATE_ID(ID_SIZE)
  }
  window.dataLayer.push(data);
  logEvent('GTM: creditCheck', data)
}

export function mktProspectQualified(lead_source: string, lead_consent: boolean) {
  const data = {
    'webpage_session_id': window.GET_WEBPAGE_SESSION_ID(),
    'aag_lead_type_id': '74',
    'aag_campaign_id': '133',
    'aag_marketing_id': window.GET_OID(),
    'aag_lead_type_name': 'Claims for Cars',
    'lead_source': lead_source,
    'lead_consent': lead_consent,
    'event_id': window.CREATE_ID(ID_SIZE),
    'facebook_fbp': window.FB_VARS._fbp,
    'facebook_fbc': window.FB_VARS._fbc,
  }

  logEvent('Marketech: Prospect Qualified', data)

  if (!window.Marketech) return;
  marktechTrack("Prospect Qualified", data);
}

export function mktProspectCreated(aag_lead_token: string, email: string, phone: string, first_name: string,
                                   last_name: string, sir_name: string, lead_source: string, lead_consent: boolean) {
  const data = {
    'webpage_session_id': window.GET_WEBPAGE_SESSION_ID(),
    'aag_lead_type_id': '74',
    'aag_campaign_id': '133',
    'aag_marketing_id': window.GET_OID(),
    'aag_lead_type_name': 'Claims for Cars',
    'lead_source': lead_source,
    'email': email,
    'phone_number': phone,
    'first_name': first_name,
    'last_name': last_name,
    'sir_name': sir_name,
    'lead_consent': lead_consent,
    'event_id': window.CREATE_ID(ID_SIZE),
    'aag_lead_token': aag_lead_token,
    'facebook_fbp': window.FB_VARS._fbp,
    'facebook_fbc': window.FB_VARS._fbc
  }

  logEvent('Marketech: Prospect Created', data)

  if (!window.Marketech) return;
  marktechTrack("Prospect Created", data);
}

type TClaimType = 'PCP' | 'DPF'

export function mktLeadCreated(aag_lead_token: string, email: string, phone: string, first_name: string,
                               last_name: string, sir_name: string, lead_source: string, claim_type: TClaimType, lead_consent: boolean) {
  const data = {
    'webpage_session_id': window.GET_WEBPAGE_SESSION_ID(),
    'aag_lead_type_id': '74',
    'aag_campaign_id': '133',
    'aag_marketing_id': window.GET_OID(),
    'aag_lead_type_name': 'Claims for Cars',
    'lead_source': lead_source,
    'email': email,
    'phone_number': phone,
    'first_name': first_name,
    'last_name': last_name,
    'sir_name': sir_name,
    'lead_consent': lead_consent,
    'event_id': window.CREATE_ID(ID_SIZE),
    'aag_lead_token': aag_lead_token,
    'claim_type': claim_type,
    'facebook_fbp': window.FB_VARS._fbp,
    'facebook_fbc': window.FB_VARS._fbc
  }

  logEvent('Marketech: Lead Created', data)

  if (!window.Marketech) return;
  marktechTrack("Lead Created", data);
}


export function mktLeadSigned(aag_lead_token: string, email: string, phone: string, first_name: string,
                              last_name: string, sir_name: string, lead_source: string, claim_type: TClaimType, lead_consent: boolean) {
  const data = {
    'webpage_session_id': window.GET_WEBPAGE_SESSION_ID(),
    'aag_lead_type_id': '74',
    'aag_campaign_id': '133',
    'aag_marketing_id': window.GET_OID(),
    'aag_lead_type_name': 'Claims for Cars',
    'lead_source': lead_source,
    'email': email,
    'phone_number': phone,
    'first_name': first_name,
    'last_name': last_name,
    'sir_name': sir_name,
    'claim_type': claim_type,
    'lead_consent': lead_consent,
    'event_id': window.CREATE_ID(ID_SIZE),
    'aag_lead_token': aag_lead_token,
    'facebook_fbp': window.FB_VARS._fbp,
    'facebook_fbc': window.FB_VARS._fbc
  }

  logEvent('Marketech: Lead Signed', data)

  if (!window.Marketech) return;
  marktechTrack("Lead Signed", data);
}

export function mktCreditCheck(aag_lead_token: string, total_agreements: number, lead_source: string, lead_consent: boolean) {
  const data = {
    'webpage_session_id': window.GET_WEBPAGE_SESSION_ID(),
    'aag_lead_type_id': '74',
    'aag_campaign_id': '133',
    'aag_marketing_id': window.GET_OID(),
    'aag_lead_type_name': 'Claims for Cars',
    'lead_source': lead_source,
    'event_id': window.CREATE_ID(ID_SIZE),
    'aag_lead_token': aag_lead_token,
    'agreement_total': total_agreements,
    'lead_consent': lead_consent,
    'facebook_fbp': window.FB_VARS._fbp,
    'facebook_fbc': window.FB_VARS._fbc
  }

  logEvent('Marketech: Lead Credit Check', data)

  if (!window.Marketech) return;
  marktechTrack("Lead Credit Check", data);
}


export function mktRatingSubmitted(rating_value: number, aag_lead_token: string, lead_source: string, lead_consent: boolean) {
  const data = {
    'rating_value': rating_value,
    'webpage_session_id': window.GET_WEBPAGE_SESSION_ID(),
    'aag_lead_type_id': '74',
    'aag_campaign_id': '133',
    'aag_marketing_id': window.GET_OID(),
    'aag_lead_type_name': 'Claims for Cars',   // Static value for lead type name
    'lead_source': lead_source,
    'lead_consent': lead_consent,
    'event_id': window.CREATE_ID(ID_SIZE),
    'aag_lead_token': aag_lead_token,
  }


  logEvent('Marketech: Rating Submitted', data)

  if (!window.Marketech) return;
  marktechTrack("Rating Submitted", data);
}

export function mktViewPage(lead_source: string, email: string, contact: { phone: string, first_name: string, last_name: string, title: string }) {
  const data = {
    webpage_session_id: window.GET_WEBPAGE_SESSION_ID(),
    aag_marketing_id: window.GET_OID(),
    event_id: window.CREATE_ID(ID_SIZE),
    facebook_fbp: window.FB_VARS._fbp,
    facebook_fbc: window.FB_VARS._fbc,
    aag_lead_type_id: '74',
    aag_campaign_id: '133',
    aag_lead_type_name: 'Claims for Cars',
    lead_source: lead_source,

    email: email,
    phone_number: contact.phone,
    first_name: contact.first_name,
    last_name: contact.last_name,
    sir_name: contact.title,
  }

  logEvent('Marketech: Viewed Page', data)

  if (!window.Marketech) return
  marktechTrack('Viewed Page', data)
}
